import { Controller } from "@hotwired/stimulus"

// Copies a value to the clipboard and shows a short confirmation.
export default class extends Controller {
  static targets = ["feedback"]
  static values = { text: String }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textValue)
    } catch {
      const input = document.createElement("input")
      input.value = this.textValue
      document.body.appendChild(input)
      input.select()
      document.execCommand("copy")
      input.remove()
    }
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.classList.remove("hidden")
      clearTimeout(this.timer)
      this.timer = setTimeout(() => this.feedbackTarget.classList.add("hidden"), 2000)
    }
  }
}
